<ng-container *ngIf="value">
    <options class="show-label bar baroptions" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
    <shared-phase-slot-manage-info-component *ngIf="selectedOptionId=='INFO'" [value]="value" [readonly]="readonly"
        (slotChanged)="onRefresh()"> </shared-phase-slot-manage-info-component>
    <shared-phase-slot-manage-log-component *ngIf="selectedOptionId=='LOG'" [value]="value" [readonly]="readonly">
    </shared-phase-slot-manage-log-component>
    <shared-phase-slot-manage-blocked-component *ngIf="selectedOptionId=='BLOCKED'" [value]="value"
        [readonly]="readonly" (refresh)="onRefresh()"> </shared-phase-slot-manage-blocked-component>
</ng-container>